import React, { ReactElement } from "react";
import { GetStaticProps } from "next";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import styles from "./style.module.scss";
import FirstSection from "@components/severalbrands/ourStoryPage/firstSection";
import SecondSection from "@components/severalbrands/ourStoryPage/secondSection";
import ThirdSection from "@components/severalbrands/ourStoryPage/thirdSection";
// import wormTopLeft from "src/components/severalbrands/lotties/topLeft.json";
// import wormTopRight from "src/components/severalbrands/lotties/topRight.json";
// import wormBottomLeft from "src/components/severalbrands/lotties/bottomLeft.json";
// import wormBottomRight from "src/components/severalbrands/lotties/bottomRight.json";
// import dynamic from "next/dynamic";

// const Player = dynamic(
//     () => import("@lottiefiles/react-lottie-player").then((mod) => mod.Player),
//     {
//         ssr: false,
//     },
// );
import { DomainInfo } from "@components/severalbrands/utils/services";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getKeyWordsForMetaTags,
    getMetaTitleDescriptionForPage,
} from "@components/severalbrands/utils";
export default function SeveralBrandsHome({
    domain,
}: {
    domain: DomainInfo;
}): ReactElement {
    const metaTags = getMetaTitleDescriptionForPage(domain, "OurStory");

    return (
        <>
            <SeveralBrandsWrapper domainInfo={domain}>
                <MetaTags
                    title={metaTags?.title ?? "Our Story | SeveralBrands.com"}
                    description={
                        metaTags?.description ??
                        "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks."
                    }
                    keyWords={getKeyWordsForMetaTags(domain)}
                />
                <section className={styles["bgStyle"]}>
                    <div className="lg:pt-28 pt-12 lg:pb-60 pb-32">
                        <FirstSection domainInfo={domain} />
                        <SecondSection domainInfo={domain} />
                        <ThirdSection domainInfo={domain} />
                    </div>
                </section>
            </SeveralBrandsWrapper>
            {/* <div className={styles["topLeft"]}>
                <Player
                    autoplay
                    loop
                    src={wormTopLeft}
                    style={{ direction: "ltr" }}
                ></Player>
            </div>
            <div className={styles["topRight"]}>
                <Player
                    autoplay
                    loop
                    src={wormTopRight}
                    style={{ direction: "ltr" }}
                ></Player>
            </div>
            <div className={styles["bottomLeft"]}>
                <Player
                    autoplay
                    loop
                    src={wormBottomLeft}
                    style={{ direction: "ltr" }}
                ></Player>
            </div>
            <div className={styles["bottomRight"]}>
                <Player
                    autoplay
                    loop
                    src={wormBottomRight}
                    style={{ direction: "ltr" }}
                ></Player>
            </div> */}
        </>
    );
}

//@ts-ignore
export const getStaticProps: GetStaticProps = async () => {
    return await initialCall("OurStory");
};
